import BaseModel from '@/utils/store/BaseModel'
import User from '@/store/models/user/User'

class UserComment extends BaseModel {
  static entity = 'usercomments'

  static fields() {
    return {
      ...super.fields(),
      text: this.string(''),
      resourceType: this.attr(null),
      createdAt: this.attr(null).nullable(),
      // threading: id of the top-level comment this one replies to (null = top-level)
      parentId: this.attr(null),
      repliesCount: this.number(0),
      // social
      likesCount: this.number(0),
      isLikedByUser: this.boolean(false),
      // relationships
      userId: this.attr(null),
      user: this.belongsTo(User, 'userId'),
      resourceId: this.attr(null),
      resource: this.morphTo('resourceId', 'resourceType'),
    }
  }
}

export default UserComment
